import styled, {keyframes} from "styled-components";
import { useContext, useEffect, useState } from "react";
import AdicionarAcessoImg from "./img/JobIcon.png"
import VipRequestImg from "./img/goldstar.png"
import MeuCadastroImg from "./img/my_register.gif"
import LogOutImg from "./img/logout.png"
import HistoricImg from "./img/manage_search.png"
import ColorEmailIcon from "./img/mailunread.png"
import { PageContext } from "../../Context/PageContext";
import Acessos from "./DashboardItems/Acessos";
import SolicitarVip from "./DashboardItems/SolicitarVip";
import MeuCadastro from "./DashboardItems/MeuCadastro";
import Home from "../Home/Home";
import { ApiConnectMessageListRequest } from "../../api/LionsUserApiConect";
import UserNotLogged from "./DashboardItems/UserNotLogged";
import AcessosMobile from "./DashboardItems/AcessosMobile";
import TopRagnarok from "../../VoteBanners/TopRagnarok";
import TopRagnarokBrasil from "../../VoteBanners/TopRagnarokBrasil";
import TicketIconImg from "./img/ticket.png"
import HistoricLogImg from "./img/historic.png";
import VipRequestLogImg from "./img/processando.png";
import MessageListLogImg from "./img/mailunread.png";

import TicketLog from "./DashboardItems/meucadastro/TicketPanel"
import HistoricLog from "./DashboardItems/meucadastro/HistoricLog";
import VipRequestLog from "./DashboardItems/meucadastro/VipRequestLog";

import MessageListLog from "./DashboardItems/meucadastro/MessageListLog";

function Dashboard(){

    const { user, setUser, isLogged, setIsLogged, dashBoardPageSelection, setDashboardPageSelection, setPage } = useContext(PageContext);

    const [messageList, setMessageList] = useState([])

    const [messageIcon, setMessageIcon] = useState("")
    const [messageNumber, setMessageNumber] = useState(0)
    const [messagePhrase, setMessagePhrase] = useState("Sem novas mensagens.")

    const [menuStyle, setMenuStyle] = useState(
        <LineMasterContainer>
            <LineItem 
                bgcolor={"rgb(194, 51, 51)"}
                onClick={() => setDashboardPageSelection(<MeuCadastro />)}>
                <MenuItemIcon img={MeuCadastroImg} />
                <LineItemSpan>Meu Cadastro</LineItemSpan>
            </LineItem>

            <LineItem
                bgcolor={"rgb(51, 150, 46)"}
                onClick={() => setDashboardPageSelection(<>{AcessosType}</>)}>
                <MenuItemIcon img={AdicionarAcessoImg} />
                <LineItemSpan>Acessos</LineItemSpan>
            </LineItem>
                
            <LineItem
                bgcolor={"rgb(46, 127, 184)"}
                onClick={() => setDashboardPageSelection(<SolicitarVip />)} >
                <MenuItemIcon img={VipRequestImg} />
                <LineItemSpan>Solicitar VIP</LineItemSpan>
            </LineItem>

            <LineItem 
                bgcolor={"rgb(194, 51, 51)"}
                onClick={() => setDashboardPageSelection(<HistoricLog />)}>
                <MenuItemIcon img={HistoricLogImg} />
                <LineItemSpan>Histórico</LineItemSpan>
            </LineItem>

            <LineItem 
                bgcolor={"rgb(194, 51, 51)"}
                onClick={() => setDashboardPageSelection(<VipRequestLog />)}>
                <MenuItemIcon img={VipRequestLogImg} />
                <LineItemSpan>Acompanhar Pedido</LineItemSpan>
            </LineItem>

            <LineItem 
                bgcolor={"rgb(194, 51, 51)"}
                onClick={() => setDashboardPageSelection(<MessageListLog />)}>
                <MenuItemIcon img={MessageListLogImg} />
                <LineItemSpan>Mensagens <br/> <NewMessageSpan>({messagePhrase})</NewMessageSpan></LineItemSpan>
            </LineItem>

            <LineItem 
                bgcolor={"rgb(194, 51, 51)"}
                onClick={() => setDashboardPageSelection(<TicketLog/>)}>
                <MenuItemIcon img={TicketIconImg} />
                <LineItemSpan>Tickets</LineItemSpan>
            </LineItem>

            <LineItem 
                    bgcolor={"rgb(194, 51, 51)"}
                    >
                <MenuItemIcon img={HistoricImg} />
                <LineItemSpan>Armazen <br/>(Em breve!)</LineItemSpan>
            </LineItem>

            <LineItem 
                bgcolor={"rgb(194, 51, 51)"}
                onClick={()=>{
                    setUser(null);
                    setIsLogged(false);
                    setPage(<Home />);
                    sessionStorage.removeItem('jwtToken');
                    window.location.reload();
                }}>
                <MenuItemIcon img={LogOutImg} />
                <LineItemSpan>Logout</LineItemSpan>
            </LineItem>
        </LineMasterContainer>
    )

    const [menuPositionBefore, setMenuPositionBefore] = useState(<></>);
    const [menuPositionAfter, setMenuPositionAfter] = useState(menuStyle);
    const [AcessosType, setAcessosType] = useState(<Acessos />)

    useEffect(() => {

        let result = ApiConnectMessageListRequest(user.userName, user.userEmail)
        result.then((response) => {

            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged />);
                 setIsLogged(false);
                 return;
                } else {

                    if(window.screen.width < 1000) {
                        setAcessosType(<AcessosMobile/>)
                        setMenuPositionBefore(menuStyle)
                        setMenuPositionAfter(<></>)
                    }

                    setTimeout(() => {  document.getElementById("MasterContainer").style.opacity = 1}, 200);

                     if(response.data == false) {
                        setMessageIcon("ColorEmailIcon")
                        setMessagePhrase(`Sem novas mensagens.`);
                    return;
                    }

                    let emailCount = 0;
            
                    response.data.map(element => {
                    if(element.readStatus == "unread") { emailCount += 1};
                    });

                    if(emailCount > 0) {
                        setMessageIcon(ColorEmailIcon);
                        setMessagePhrase(`${emailCount} - Novas mensagens`);
                    } else { 
                        setMessageIcon("ColorEmailIcon")
                        setMessagePhrase(`Sem novas mensagens.`);
                        setMessageList(response)
                    }
                }
            })
        
    },[])

    return(
        <MasterContainer id="MasterContainer">

            <MenuContainer>
                <BannerContainer>
                    <PainelSpan><b>Painel de controle</b></PainelSpan>
                    <Span>Aqui você pode criar contas, solicitar seu acesso VIP e muito mais.</Span>
                    <Span>usuário logado como:  <UserColor>{user.userName}!</UserColor></Span>  
                </BannerContainer>

                { menuPositionBefore }

                { dashBoardPageSelection }
            </MenuContainer>

            { menuPositionAfter }

        </MasterContainer>

    )
}


export default Dashboard


const MasterContainer = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-between;
    width: 1100px;
    //flex-direction: column;
    padding: 0px;
    opacity: 0;
    transition: .4s ease-in-out;
    //border: solid 2px black;
    margin-bottom: 10px;

    @media(max-width: 1000px) {
        width: 95vw;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`

const MenuContainer = styled.div`
    width: 880px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    //border: 1px solid;
    border-radius: 5px;
    padding: 5px 0px;
    //background-color: rgba(0, 0, 0, 0.3);

    @media(max-width: 1000px) {
        width: 100%;
        align-items: center;
        justify-content: center;
    }
`

const BannerContainer = styled.div`
    display: flex;
    align-items: start;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    border-radius: 10px;
    padding: 20px 0px;
    scale: 1;
    //border: solid 1px rgba(0,0,0, .2);
    color: white;
    margin: 0px 0px 0px 0px;
    transition: .3s ease-in-out;
    background-color: rgba(0, 0, 0, 0.7);
    cursor: pointer;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
    
    &:hover {
        //transform: translate(-5px, -5px);
        //box-shadow: 10px 10px 10px 0px black;
    }

    @media(max-width: 1000px) {
        //padding: 10px 10px;
        margin: 10px 0px 10px 0;
        //border: solid 1px rgba(0,0,0, 1);
        align-items: center;
        justify-content: center;
        width: 95%;
    }
    
`

const PainelSpan = styled.span`
    font-size: 30pt;
    width: 100%;
    //text-align: justify;
    //border: solid 1px black;
    padding: 0 0 0 20px;

    @media(max-width: 1000px) {
        font-size: 24pt;
        text-align: left;
        margin-bottom: 10px;
    }
`;

const Span = styled.span`
    display: flex;
    align-items: center;
    width: 500px;
    font-size: 12pt;
    margin: 5px 0px;
    justify-content: start;
    //border: solid 2px black;
    padding: 0 0 0 20px;

    @media(max-width: 1000px) {
        width: 100%;
        font-size: 12pt;
        text-align: left;
    }
`;


const ColorChangeAnimation = keyframes`
       0% {color: rgb(0,0,0)}
       15% {color: rgb(255, 0, 0)}
       30% {color: rgb(6, 162, 6)}
       45% {color: rgb(0, 93, 174)}
       60% {color: rgb(6, 162, 6)}
       75% {color: rgb(255, 0, 0)}
       100% {color: rgb(0,0,0)}
   `

const UserColor = styled.span`
    color: rgb(0, 0, 0);
    //border: 1px solid black;
    background-color: rgba(255, 255, 255, 1);
    padding: 5px 10px;
    font-size: 10pt;
    font-weight: bold;
    border-radius: 5px;
    margin-left: 20px;
    //animation: ${ColorChangeAnimation} 10s ease-in-out infinite;
`;


const LineMasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 10px;
    border-radius: 5px;
    //margin-bottom: 30px;
    //border: solid;
    background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
        flex-direction: column;
        width: 90vw;
        align-items: center;
        padding: 10px 0;
    }
`



const LineItem = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0 5px;
    width: 170px;
    height: 60px;
    color: white;
    font-size: 12pt;
    font-weight: bold;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 5px;
    transition:  .3s ease-in-out;
    opacity: 1;
    margin: 5px 0px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover{
    background-color: ${props => props.bgcolor};
    scale: 1.1;
    }

    @media(max-width: 1000px) {
        width: 100%;
        align-items: center;
        margin: 5px 0px;
        scale: .9;
        justify-content: center;

        &:hover{
            background-color: ${props => props.bgcolor};
            scale: 1.0;
        }
    }
`

const MenuItemIcon = styled.div`
    background-image: url(${props => props.img});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 30px;
    height: 30px;
    margin: 0px 10px 0px 10px;

    @media(max-width: 1000px) {
        width: 40px;
        height: 40px;
        margin: 0px 20px;
    }

`

const LineItemSpan = styled.span`
    //border: solid;
    width: 130px;
    display: flex;
    flex-direction: column;
    justify-content: center;

     @media(max-width: 1000px) {
        width: 200px;
        font-size: 14pt;
    }
    
`

const NewMessageSpan = styled.span`
    font-size: 10pt;
    font-weight: normal;

`

const MessageReadStatusIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
    transition: .3s ease-in-out;
    margin-right: 5px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.3;
    }
`

const MasterNotice = styled.div`
    display: flex;
    margin-bottom: 30px ;
    font-size: 14pt;
    align-items: center;
`




